<div class="hol-dialog-wrapper crisis-task-modal hol-modal">
  <mat-toolbar>
    <div mat-dialog-title>
      <span>
        {{ 'ECL.MODALS.TASK.ADD_TASK' | translate }}
      </span>
    </div>
    <app-acl-selector
      #aclSelector
      class="acl-full-width"
      [limitTo]="acl"
      [moduleName]="'ecl'"
      [object]="crisisTask"
      [formGroup]="form"
      [isCompact]="true"
      [readOnly]="false"
      [aclObject]="crisisTask"
      [startAllSelected]="true"
      alwaysOneSelected="true"
    ></app-acl-selector>
    <button mat-dialog-close mat-icon-button tabindex="-1">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>
  <mat-dialog-content *ngIf="isSaving">
    <app-loading class="full-loader"></app-loading>
  </mat-dialog-content>
  <mat-dialog-content *ngIf="!isSaving">
    <form [formGroup]="form" class="content-grid cols-container">
      <div class="crisis-task-modal__content">
        <div class="section">
          <app-section-with-title [icon]="'diversity_3'" [titleKey]="'ECL.MODALS.TASK.FUNCTION'">
            <mat-form-field *ngIf="functionActivated.length">
              <mat-label>{{ 'ECL.MODALS.TASK.SELECT_FUNCTION' | translate }}</mat-label>
              <mat-select
                (ngModelChange)="selectTaskCode($event)"
                [ngModelOptions]="{ standalone: true }"
                [ngModel]="functionsUserForCrisisSelected"
              >
                <mat-optgroup label="{{ 'ECL.MODALS.TASK.YOUR_FUNCTION' | translate }}">
                  <mat-option *ngFor="let fUser of userFunctions" [value]="fUser">
                    <span> {{ fUser.shortTitle }} - {{ fUser.title }} </span>
                    <app-acl-indicator [object]="{ companies: fUser.companies, companiesObj: [] }"></app-acl-indicator>
                  </mat-option>
                </mat-optgroup>
                <mat-optgroup label="{{ 'ECL.MODALS.TASK.OTHER_FUNCTION' | translate }}">
                  <mat-option *ngFor="let fUser of otherFunctions" [value]="fUser">
                    <span> {{ fUser.shortTitle }} - {{ fUser.title }} </span>
                    <app-acl-indicator [object]="{ companies: fUser.companies, companiesObj: [] }"></app-acl-indicator>
                  </mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>
          </app-section-with-title>
        </div>
        <app-section-with-title [icon]="'edit'" [titleKey]="'ECL.MODALS.TASK.TITLE'">
          <input
            maxlength="140"
            [placeholder]="titlePlaceHolder"
            type="text"
            [(ngModel)]="crisisTask.taskTitle"
            [ngModelOptions]="{ standalone: true }"
            (focusout)="titlePlaceHolder = defaultTitlePlaceHolder"
            (focusin)="titlePlaceHolder = ''"
          />
        </app-section-with-title>
        <br />
        <app-section-with-title [icon]="'rule'" [titleKey]="('ECL.MODALS.TASK.OUTPUT_TITLE' | translate) + ' *'">
          <input
            maxlength="70"
            [placeholder]="outputTitlePlaceHolder"
            type="text"
            [(ngModel)]="crisisTask.outputTitle"
            [ngModelOptions]="{ standalone: true }"
            (focusout)="outputTitlePlaceHolder = defaultOutputTitlePlaceHolder"
            (focusin)="outputTitlePlaceHolder = ''"
          />
        </app-section-with-title>
        <br />
        <app-section-with-title [icon]="'badge'" [titleKey]="'ECL.MODALS.TASK.OUTPUT_DATA_LABEL' | translate">
          <input
            maxlength="70"
            [placeholder]="outputDataLabelPlaceHolder"
            type="text"
            [(ngModel)]="crisisTask.outputDataLabel"
            (ngModelChange)="outputDataLabelChange($event)"
            [ngModelOptions]="{ standalone: true }"
            (focusout)="outputDataLabelPlaceHolder = defaultOutputDataLabelPlaceHolder"
            (focusin)="outputDataLabelPlaceHolder = ''"
          />
        </app-section-with-title>
        <br />
        <div class="task-modal-column">
          <app-section-with-title [icon]="'task'" [titleKey]="'ECL.MODALS.TASK.DESCRIPTION'">
            <form name="markdownForm">
              <md-editor
                #mdEditor
                [(ngModel)]="crisisTask.taskDescription"
                [ngModelOptions]="{ standalone: true }"
                [options]="options"
                mode="editor"
                name="Content"
              >
              </md-editor>
            </form>
          </app-section-with-title>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="action-bar">
      <button
        class="action action-validate"
        [disabled]="
          !functionsUserForCrisisSelected ||
          !crisisTask.taskTitle ||
          !crisisTask.outputTitle ||
          crisisTask.taskTitle.trim().length === 0 ||
          crisisTask.outputTitle.trim().length === 0
        "
        (click)="saveCrisisTask()"
      >
        <span><i aria-hidden="true" class="fa fa-check"></i></span>
        <span>{{ 'COMMON.ADD' | translate }}</span>
      </button>
    </div>
  </mat-dialog-actions>
</div>
